import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';

import { usePublishFlightCampaign, useUnpublishFlightCampaign } from '~/hooks/apis/flights/useCampaignBuilder';

import { campaignStatus } from '../FlightsCampaigns/campaignStatus';
import { useFlightCampaign } from '../hooks/useFlightCampaign';
import { useFlightCampaignDeals } from '../hooks/useFlightCampaignDeals';

export default function CampaignPublication({ campaignId }: { campaignId: string }) {
  const campaign = useFlightCampaign(campaignId);
  const deals = useFlightCampaignDeals(campaignId);
  const publish = usePublishFlightCampaign();
  const unpublish = useUnpublishFlightCampaign();
  const pending = publish.isPending || unpublish.isPending;
  const loadError = campaign.error ?? deals.error;
  const error = loadError ?? publish.error ?? unpublish.error;
  if (campaign.loading || deals.loading) return <CircularProgress />;
  return (
    <Stack gap={2}>
      {error && <Alert severity="error">{error.message}</Alert>}
      {campaign.data && (
        <>
          <Typography variant="h5">{campaign.data.title}</Typography>
          <Typography>Status: {campaignStatus(campaign.data)}</Typography>
          {deals.data.map((deal) => (
            <Typography key={deal.id}>
              {deal.dealName} · {deal.originAirportCode} to {deal.destinationAirportCode} · ${deal.perAdultPrice} per
              adult
            </Typography>
          ))}
          <Stack direction="row" gap={2}>
            <Button component={Link} to={`/flights/campaigns/${campaignId}`}>
              Edit campaign
            </Button>
            {campaign.data.published_at === null ? (
              <Button
                variant="contained"
                disabled={pending || !!loadError || !deals.data.length}
                onClick={() => publish.mutate(campaignId)}
              >
                Publish campaign and deals
              </Button>
            ) : (
              <Button disabled={pending} onClick={() => unpublish.mutate(campaignId)}>
                Unpublish campaign and deals
              </Button>
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
}
